import { MaterialSelection, ModelCategory, ProjectLayoutModel, User } from '@paragon/contract-library';

export function createProjectModel(name: string, materialSelection: MaterialSelection, user: User): ProjectLayoutModel {
  return {
    type: 'project',
    modelType: 'Project',
    category: ModelCategory.Project,

    guid: crypto.randomUUID(),
    archived: false,
    organization: user.organization,
    name,
    materialSelection,
    createdAt: new Date().toISOString(),
    region: null,
    designProgram: null,
    contactName: `${user.firstName} ${user.lastName}`,
    contactEmail: user.email,
    contactPhone: user.phone,
    customerName: null,
    lotNumber: null,
    address: null,
    city: null,
    subdivision: null,
    model: null,
    buildingDesignerName: null,
    buildingDesignerAddress: null,
    buildingDesignerCity: null,
    buildingDesignerState: null,
    buildingDesignerLicenseNumber: null,
    projectSalesman: null,
    assigneeEmail: null,
    dueDate: null,
    status: 'New',
    endConditionPresetsLeft: [],
    endConditionPresetsRight: [],
  };
}
